module.exports = __webpack_public_path__ + "img/Big Data Infrastructure Hadoop_Silicon Stone Education_20200908.9a33e020.jpg";